<template>
  <custom-dialog width="75%" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="search" style="height: 40px; overflow: hidden">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right; margin-right: 0">
            <custom-date-picker
              v-model="formSearch.billPaymentTime"
              type="datetimerange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              :picker-options="pickerOptionDisAfter"
              style="width: 100%"
              :startPlaceholder="$t('fms_invoice_wait_dialog.ying_shou_ri_qi')"
              :endPlaceholder="$t('fms_invoice_wait_dialog.ying_shou_ri_qi')"
              @change="onPageChange({ page: 1 })"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter('keyword')">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('fms_invoice_wait_dialog.he_tong_bian_hao')">
            <el-input v-model="formSearch.contractNo" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item :label="$t('fms_invoice_wait_dialog.xiang_mu_ming_cheng')">
            <el-input v-model="formSearch.locationName" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item :label="$t('fms_invoice_wait_dialog.ying_fu_gong_si')">
            <el-input v-model="formSearch.payableOrgName" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table tableCode="invoiceWait" type="checkbox" v-model="tableSelect" :data="tableList"  @filter="filterChange"></custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import commonMixin from '../../mixins/commonMixin';

export default {
  mixins: [dialogMixins, commonMixin, resetFormSearchMixins],
  data() {
    return {
      tableSelect: [],
      tableList: [],
      totalRows: null,
      formSearch: {
        keyword: '',
        billTradeState: [0, 1, 6, 10],
        paymentOrReceivable: false,
        pageNum: 1,
        pageSize: 50,
        billPaymentTime: [],
        contractNo: '', // 合同编号
        locationName: '', // 项目名称
        payableOrgName: '', // 应付公司
      },
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.$getJSON(apis.paymentToAddInvoicePage, this.formSearch).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 确认保存
    confirm: function () {
      if (!this.tableSelect.length) {
        this.$message.error(this.$t('fms_invoice_wait_dialog.qxzdkpzd'));
        return;
      }
      const partnerInvoiceId = this.tableSelect[0].payableOrgId;
      const billIdList = this.tableSelect.map(item => item.billId);
      const invoiceType = 1;
      const invoiceClass = 1;
      this.$postJSON(apis.invoiceMark, { partnerInvoiceId, billIdList, invoiceType, invoiceClass }, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success');
        this.$emit('close');
      });
    },
  },
};
</script>

<style lang="scss"></style>
